import React from 'react';
import ServicePageTemplate, { ALL_SERVICES } from './ServicePageTemplate';

const pageData = {
  seo: {
    title: 'Digital Marketing & Strategy Agency | RojrzTech',
    description:
      'RojrzTech is a results-driven digital marketing agency offering SEO, PPC, social media marketing, content strategy, and email marketing to grow your business.',
  },
  hero: {
    badge: 'DIGITAL MARKETING EXPERTS',
    slides: [
      {
        heading: { pre: 'Dominate Your', gold: 'Market Online' },
        subheading:
          'As a digital marketing company, we create data-driven campaigns that put your brand in the spotlight and deliver measurable results.',
        pills: ['SEO', 'PPC', 'Social Media', 'Content', 'Email'],
        image: '/dm.png',
      },
      {
        heading: { pre: 'Data-Driven Marketing That', gold: 'Converts' },
        subheading:
          'We use advanced analytics and proven strategies to turn clicks into customers, maximizing your ROI and growing your bottom line.',
        pills: ['Google Ads', 'Meta Ads', 'Analytics', 'CRO', 'ROI'],
        image: '/dm1.png',
      },
      {
        heading: { pre: 'Grow Your', gold: 'Brand Digitally' },
        subheading:
          'From brand awareness to lead generation, our full-service digital marketing strategies help your business grow and thrive in the digital age.',
        pills: ['Brand Strategy', 'Lead Gen', 'Automation', 'Reporting', 'Growth'],
        image: '/dm.png',
      },
    ],
  },
  servicesCards: {
    title: 'Our Comprehensive Digital Marketing & Strategy Services',
    subtitle:
      'We are a full-service digital marketing agency that helps businesses across all industries achieve their goals through targeted, data-driven strategies.',
    cards: [
      {
        icon: '🔍',
        title: 'Search Engine Optimization (SEO)',
        description:
          'Visibility is vital. We fine-tune your site to implement the latest SEO strategies so you get the search placement you deserve.',
      },
      {
        icon: '📢',
        title: 'Pay-Per-Click Advertising (PPC)',
        description:
          'Targeted Google Ads and Bing Ads campaigns that put you in front of your ideal customers at exactly the right moment.',
      },
      {
        icon: '📱',
        title: 'Social Media Marketing',
        description:
          'Strategic social media campaigns across Facebook, Instagram, LinkedIn, and TikTok that build community and drive engagement.',
      },
      {
        icon: '✍️',
        title: 'Content Marketing & Strategy',
        description:
          'High-quality, SEO-optimized content that attracts, educates, and converts your target audience into loyal customers.',
      },
      {
        icon: '📧',
        title: 'Email Marketing & Automation',
        description:
          'Personalized email campaigns and automated workflows that nurture leads and drive repeat business from existing customers.',
      },
      {
        icon: '📊',
        title: 'Analytics & Reporting',
        description:
          'Comprehensive reporting and analytics dashboards that give you full visibility into campaign performance and ROI.',
      },
    ],
  },
  features: {
    title: 'Digital Marketing Services for Accelerated Business Growth',
    subtitle:
      'Develop custom marketing strategies that enhance your online reputation, elevate your brand presence, and expand your customer base.',
    items: [
      'On-Page SEO',
      'Technical SEO',
      'Link Building',
      'Google Ads',
      'Facebook Ads',
      'Instagram Ads',
      'Content Creation',
      'Email Campaigns',
      'Social Media Mgmt',
      'Competitor Analysis',
      'Conversion Tracking',
      'Monthly Reporting',
    ],
  },
  excellence: {
    title: 'Collaborative Excellence',
    subtitle:
      "At RojrzTech, we prioritize collaboration to ensure the best marketing outcomes for our clients. We maintain constant communication, refining your strategy until you're completely satisfied.",
    cards: [
      {
        icon: '🎯',
        title: 'Targeted Audience Reach',
        description:
          'We identify and target your ideal customer segments with precision, ensuring your marketing budget is spent where it matters most.',
      },
      {
        icon: '📈',
        title: 'Measurable Results & ROI',
        description:
          'Every campaign is tracked and measured. We provide transparent reporting so you always know exactly how your investment is performing.',
      },
      {
        icon: '🔒',
        title: 'Brand Safety & Compliance',
        description:
          'We ensure all campaigns comply with platform policies and industry regulations, protecting your brand reputation at all times.',
      },
      {
        icon: '⚡',
        title: 'Agile & Adaptive Strategy',
        description:
          'The digital landscape changes fast. Our agile approach means we continuously optimize your campaigns for peak performance.',
      },
      {
        icon: '🤝',
        title: 'Dedicated Account Management',
        description:
          'You get a dedicated marketing expert who understands your business, your goals, and works as an extension of your team.',
      },
      {
        icon: '🚀',
        title: 'Scalable Campaign Growth',
        description:
          'Our marketing systems are built to scale alongside your business, from local campaigns to global brand domination.',
      },
    ],
  },
  relatedServices: ALL_SERVICES.filter((s) => s.href !== '/services/digital-marketing'),
};

const DigitalMarketing = () => <ServicePageTemplate pageData={pageData} />;
export default DigitalMarketing;
